import { render, staticRenderFns } from "./ApplicationRestrictions.vue?vue&type=template&id=669ced9b&scoped=true"
import script from "./ApplicationRestrictions.vue?vue&type=script&lang=js"
export * from "./ApplicationRestrictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ced9b",
  null
  
)

export default component.exports